import { render, staticRenderFns } from "./ProductGroupSelect.vue?vue&type=template&id=8f42b7fe"
import script from "./ProductGroupSelect.vue?vue&type=script&lang=ts"
export * from "./ProductGroupSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports